import { useQuery } from 'react-query';

import { getNodes } from './queries';

export const useNodes = (config) => useQuery('nodes', getNodes, config);
